<template>
    
    <div class="list-item list-item--article"
        :class="css"
        ref="article">
        <div class="cell cell--cb">
            <input type="checkbox" :disabled="!purchasable || !data.articleVariation.article.isActive" :value="data" v-model="model"/>
        </div>
        <div class="cell cell--ref">
            <AddToFavorite
                :article="data.articleVariation.article"
                :variation="data.articleVariation" />
        </div>
        <div class="cell cell--lists">
            <ul class="list__content catalog text-listname" v-if="data.articleVariation.listes">
                <li class="text-listname" v-for="liste in data.articleVariation.listes"
                    :key="liste.id">
                    {{ liste.libelle }}
                </li>
            </ul>
        </div>
        <div class="cell cell--main">
            <ArticleTitle :article="data.articleVariation.article" />
        </div>
        <div class="cell cell--variation">
            <span v-if="data.articleVariation && data.articleVariation.uvCode == 'UNI'">{{ data.articleVariation.uvCodeLibelle }}</span>
            <span v-if="data.articleVariation && data.articleVariation.uvCode != 'UNI'">{{ data.articleVariation.uvCodeLibelle }} x{{ data.articleVariation.uvCoef }}</span>
        </div>
        <div class="cell cell--price">
            <Price :amount="price" currency="EUR" />
        </div>
        <div class="cell cell--actions">
            <AddToCart
                :article="data.articleVariation.article"
                :variation="data.articleVariation" />
        </div>
    </div>

</template>

<script>

import AddToCart from '@/components/addToCart/AddToCart.vue'
import AddToFavorite from '@/components/addToFavorite/AddToFavorite.vue'
import ArticleTitle from '@/components/articleTitle/ArticleTitle.vue'
import Price from '@/components/price/Price.vue'

export default {

    props: {

        data: {
            type: Object,
            required: true
        },

        purchasable: {
            type: Boolean,
            required: false,
            default: true
        },

        value: Array
    },
    
    computed: {

        css: function () {
            return ''
        },        

        model: {

            get() {
                return this.value;
            },

            set(value) {
                this.$emit("input", value);
            }
        },

        price: function() {

            if ( this.data.articleVariation && this.data.articleVariation.price ) {
                return ( this.data.articleVariation.price + this.data.articleVariation.tgap )
            }

            return null
        }
    },

    components: {
        AddToCart,
        AddToFavorite,
        ArticleTitle,
        Price,
    }
}
</script>

<style>

.list-item.list-item--article {    
    flex-direction: row;
    flex-wrap: wrap;
    border-bottom: 1px solid #e3e3e3;
    padding: 1rem 0 1rem 2rem;
}

.list-item.list-item--article .cell.cell--actions {
    display: inherit;
}

.list-item.list-item--article .cell.cell--cb {
    position: absolute;
    left: 0;
    top: 1rem;
}

.list-item.list-item--article .cell.cell--main {
    width: 100%;
}

.list-item.list-item--article .cell.cell--price {
    flex: 1;
    justify-content: flex-end;
    padding-right: 1rem;
}

.list-item.list-item--article .cell.cell--ref {
    width: 100%;
}

.text-listname {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media screen and (min-width: 800px) {

    .list-item.list-item--article {
        flex-direction: row;
        flex-wrap: nowrap;
        border: 0 none;
        padding: 0;
    }

    .list-item.list-item--article .cell.cell--cb {
        position: initial;
    }

    .list-item.list-item--article .cell.cell--main {
        width: auto;
    }

    .list-item.list-item--article .cell.cell--price {
        flex: 0.5;
        justify-content: flex-start;
        padding: 0 0.5rem;
    }

    .list-item.list-item--article .cell.cell--ref {
        min-width: 140px;
        flex: 0.7;
        padding: 1rem 0 1rem 0rem;
    }

    .list-item.list-item--article .cell.cell--lists {
        flex: 1;
        padding: 1rem 0 1rem 0rem;
    }

    .list-item.list-item--article .cell.cell--variation {
        flex: 0.8;
        padding: 1rem 0 1rem 0rem;
    }
} 

</style>